// extracted by mini-css-extract-plugin
module.exports = {"main":"customInput_main__2DmJJ","input":"customInput_input__WEbmf","icon":"customInput_icon__rRrHE"};